<script setup lang="ts">
  import {
    Button,
    ButtonSize,
    ButtonVariant,
    Tooltip,
  } from '@tundr/ds-components';
  import { useToast } from '@tundr/toast';
  import { useLocale } from '@tundr/i18n';
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { copiableCellClass } from './CopiableCell.css.ts';
  import { useClipboard } from '@vueuse/core';
  import { computed, useSlots, watchEffect } from 'vue';

  const { t } = useLocale('table');
  const { showInfo } = useToast();

  const { copy, copied } = useClipboard();

  const slots = useSlots();

  defineOptions({
    inheritAttrs: false,
  });

  const text = computed<string>(() => {
    return (slots.default && (slots.default()[0].children as string)) || '';
  });

  watchEffect(() => {
    if (copied.value) {
      showInfo({
        message: t('table.copy_to_clipboard.success.title'),
      });
    }
  });

  const onCopy = () => {
    copy(text.value);
  };
</script>

<template>
  <div :class="copiableCellClass">
    <Tooltip :title="t('table.copy_to_clipboard.tooltip')">
      <Button
        :variant="ButtonVariant.Icon"
        :size="ButtonSize.SM"
        is-ghost
        :icon-name="TUNDR_ICONS.COPY"
        :aria-label="t('table.copy_to_clipboard.tooltip')"
        @click.stop="onCopy"
      />
    </Tooltip>
    <slot />
  </div>
</template>
